import { render, staticRenderFns } from "./payouts.vue?vue&type=template&id=0a5e3c96&"
import script from "./payouts.vue?vue&type=script&lang=js&"
export * from "./payouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports